module.exports = __webpack_public_path__ + "img/header-phone.103771c9.jpg";